export default __webpack_public_path__ + "static/Entenda0101-4fbcbfe0e6d423dafd9913d305756bc4.jpg";